import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import adminCartService from "../../services/adminCartService";

// Cart Management Thunks
export const getAllCartsThunk = createAsyncThunk(
  "adminCart/getAllCarts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await adminCartService.getAllCarts(params);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getCartByIdThunk = createAsyncThunk(
  "adminCart/getCartById",
  async (cartId, { rejectWithValue }) => {
    try {
      const response = await adminCartService.getCartById(cartId);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getUserCartThunk = createAsyncThunk(
  "adminCart/getUserCart",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await adminCartService.getUserCart(userId);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const clearUserCartThunk = createAsyncThunk(
  "adminCart/clearUserCart",
  async ({ cartId, reason }, { rejectWithValue }) => {
    try {
      const response = await adminCartService.clearUserCart(cartId, { reason });
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Exchange Item Verification Thunks
export const getPendingExchangeItemsThunk = createAsyncThunk(
  "adminCart/getPendingExchangeItems",
  async (params, { rejectWithValue }) => {
    try {
      const response = await adminCartService.getPendingExchangeItems(params);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getExchangeItemDetailsThunk = createAsyncThunk(
  "adminCart/getExchangeItemDetails",
  async ({ cartId, exchangeItemId }, { rejectWithValue }) => {
    try {
      const response = await adminCartService.getExchangeItemDetails(
        cartId,
        exchangeItemId
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const verifyExchangeItemThunk = createAsyncThunk(
  "adminCart/verifyExchangeItem",
  async ({ cartId, exchangeItemId, data }, { rejectWithValue }) => {
    try {
      const response = await adminCartService.verifyExchangeItem(
        cartId,
        exchangeItemId,
        data
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const rejectExchangeItemThunk = createAsyncThunk(
  "adminCart/rejectExchangeItem",
  async ({ cartId, exchangeItemId, reason }, { rejectWithValue }) => {
    try {
      const response = await adminCartService.rejectExchangeItem(
        cartId,
        exchangeItemId,
        { reason }
      );
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const bulkVerifyExchangeItemsThunk = createAsyncThunk(
  "adminCart/bulkVerifyExchangeItems",
  async (items, { rejectWithValue }) => {
    try {
      const response = await adminCartService.bulkVerifyExchangeItems({
        items,
      });
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Analytics Thunks
export const getCartAnalyticsThunk = createAsyncThunk(
  "adminCart/getCartAnalytics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await adminCartService.getCartAnalytics();
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const getAbandonedCartsThunk = createAsyncThunk(
  "adminCart/getAbandonedCarts",
  async (params, { rejectWithValue }) => {
    try {
      const response = await adminCartService.getAbandonedCarts(params);
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

export const markAbandonedCartsThunk = createAsyncThunk(
  "adminCart/markAbandonedCarts",
  async (daysOld, { rejectWithValue }) => {
    try {
      const response = await adminCartService.markAbandonedCarts({ daysOld });
      return response;
    } catch (error) {
      const errorMessage = error.response?.data?.error || error.message;
      return rejectWithValue(errorMessage);
    }
  }
);

// Actions
export const clearAdminCartError = createAction("adminCart/clearError");
export const resetSelectedCart = createAction("adminCart/resetSelectedCart");
export const setCartFilter = createAction("adminCart/setCartFilter");
export const resetExchangeItemDetails = createAction(
  "adminCart/resetExchangeItemDetails"
);
